import { useState, useEffect, ChangeEvent } from 'react';
import {
  //  getHeadTypeLoftData,
  getHeadTypeFamilyData,
  getFamilyData,
  getHeadModelHandForDropdownDtoData,
  getHeadModelsByManufacturerAndTypeForDropdownDataWedges,
  getHandLookupData,
  getSwingWtPrefixData,
  getSwingWtSuffixData,
  getWedgeShaftByShaftNameForDropdownData,
  getGripSizeData,
  getShaftLengthDigitData,
  getShaftLengthFractionData,
  getFractionData,
  getDigitData,
  getHeadFinishWedgeData,
  getLoftDigitData,
  getLoftFractionData,
  getLieDigitsData,
  getLieFractionData,
  getIronShaftByShaftNameForDropdownData,
} from '@/service/TourBagStaticService';
import { HandLookup, HeadModelHandForDropdownDto, HeadModelForDropdownDto } from '@/api/models';
import EditableDropdown from '@/common/EditableDropdown';
import EditableTile from '@/common/EditableTile';
import { IDropdownOption } from '@/common/EditableDropdown/EditableDropdown';
import { TourBagDetail } from '@/api/models';
import { createCombinedShaftLengthDigitFractionList, normalizeString } from '@/utils';
import { ShaftLengthDigitFractionDto } from '@/utils/createCombinedShaftLengthDigitFractionList';
import styles from './Edit.module.scss';
import clubStyles from '../Club.module.scss';
import { LoftLieHelper, ShaftHelper } from '@/library';
import { IShaftOptionMap } from '@/library/ShaftHelper';
import FinalHeadWeightModal, { IFinalHeadWeightIron } from './FinalHeadWeightModal';
import { calculateFinalHeadWeight } from '../Iron/caluclateFinalHeadWeight';
import Tile from '@/common/Tile';
import TextAreaInput from '@/common/TextArea/Input';
interface IProps {
  wedge: TourBagDetail;
  closeEditForm: () => void;
  pageType: string;
  // eslint-disable-next-line no-unused-vars
  saveEditForm: (tourBag: TourBagDetail) => void;
}

interface IWeightCodes {
  swingWeightId: number; //autonumber
  name: string; //concatenation of prefix+suffix
  swingWtPrefixId: number;
  swingWtPrefixName: string;
  swingWtSuffixId: number;
  swingWtSuffixName: string;
}

export default function Edit({ wedge, saveEditForm, closeEditForm, pageType }: IProps) {
  const [thisWedge, setThisWedge] = useState({ ...wedge, ct: wedge.ct || 0 });
  const [currentHandId, setCurrentHandId] = useState(0); //the driver saves hand as "RH" and not a number. So need to save it in state to make lookups easier
  const [shaftLengthName, setShaftLengthName] = useState(''); //driver doesn't have a field to uniquely identify the length. So use this instead.
  //const [loftOptionId, setLoftOptionId] = useState('');
  const [loftOptions, setLoftOptions] = useState([] as IDropdownOption[]);
  const [wedgeLoftKey, setWedgeLoftKey] = useState('');
  const [lieOptions, setLieOptions] = useState([] as IDropdownOption[]);
  const [wedgeLieKey, setWedgeLieKey] = useState('');
  const [handData, setHandData] = useState([] as HandLookup[]);
  const [familyOptions, setFamilyOptions] = useState([] as IDropdownOption[]);
  const [handModels, setHandModels] = useState([] as HeadModelHandForDropdownDto[]);
  const [familyModelData, setFamilyModelData] = useState([] as HeadModelForDropdownDto[]);
  const [modelOptions, setModelOptions] = useState([] as IDropdownOption[]);
  const [swingWtData, setSwingWtData] = useState([] as IWeightCodes[]);
  const [swingWtOptions, setSwingWtOptions] = useState([] as IDropdownOption[]);
  const [swingWtListId, setSwingWtListId] = useState(0); //need to save the mapping id b/c it's not in the driver record
  //  const [shaftOptions, setShaftOptions] = useState([] as IDropdownOption[]);
  const [shaftDropdownData, setShaftDropdownData] = useState<IShaftOptionMap>();
  const [shaftId, setShaftId] = useState(''); //driver doesn't store shaftID, so need to do it here
  const [gripSizeOptions, setGripSizeOptions] = useState([] as IDropdownOption[]);
  const [shaftLengthFractionData, setShaftLengthFractionData] = useState([] as ShaftLengthDigitFractionDto[]);
  const [shaftLengthFractionOptions, setShaftLengthFractionOptions] = useState([] as IDropdownOption[]);
  const [headFinishWedgeOptions, setHeadFinishWedgeOptions] = useState([] as IDropdownOption[]);
  const [wedgeLoftOptions, setWedgeLoftOptions] = useState<LoftLieHelper.ILoftOptionMap>();
  const [wedgeLieOptions, setWedgeLieOptions] = useState<LoftLieHelper.ILieOptionMap>();
  const [showFinalHWModal, setShowFinalHWModal] = useState(false);
  const [headWeight, setHeadWeight] = useState(thisWedge.headWeight || 0);
  const [drill, setDrill] = useState(thisWedge.drill);
  const [tipPlug, setTipPlug] = useState(thisWedge.tipPlug);
  const [glueWeight, setGlueWeight] = useState(thisWedge.glueWeight);
  const [leadTape, setLeadTape] = useState(thisWedge.leadTape);
  const finalHeadWeight = calculateFinalHeadWeight({ headWeight, drill, tipPlug, glueWeight, leadTape });
  const finalHWWedge: TourBagDetail = { ...thisWedge, headWeight, drill, tipPlug, glueWeight, leadTape };

  const WEDGE_HEAD_TYPE_ID = 5;
  const handOptions = [
    { id: 'RH', label: 'Right' },
    { id: 'LH', label: 'Left' },
  ] as IDropdownOption[];
  const rndRibOptions = [
    { id: 'Round', label: 'Round' },
    { id: 'Rib', label: 'Rib' },
  ] as IDropdownOption[];
  const logoOptions = [
    { id: 'Up', label: 'Up' },
    { id: 'Down', label: 'Down' },
  ] as IDropdownOption[];

  const headTypeId = 5; //Wedge

  useEffect(() => {
    const asyncProc = async () => {
      const handLookup = await getHandLookupData();
      setHandData(handLookup);
      const currentHandIdValue = getCurrentHandId(thisWedge.hand, handLookup);
      setCurrentHandId(currentHandIdValue);

      const headFinisheWedgeData = await getHeadFinishWedgeData();
      const finishData = headFinisheWedgeData.map((finish) => {
        return { id: finish.headFinishId.toString(), label: finish.name } as IDropdownOption;
      });
      setHeadFinishWedgeOptions(finishData);

      const headTypeFamilyData = await getHeadTypeFamilyData(headTypeId);
      const familyModels = await getHeadModelsByManufacturerAndTypeForDropdownDataWedges();
      setFamilyModelData(familyModels);
      const familyData = await getFamilyData(headTypeFamilyData.map((d) => d.familyId));
      setFamilyOptions(
        familyData.map((family) => {
          return { id: family.familyId.toString(), label: family.name } as IDropdownOption;
        }),
      );
      const handModelList = await getHeadModelHandForDropdownDtoData();
      setHandModels(handModelList);
      const familyModelList = getModels(thisWedge.familyId, currentHandIdValue, handModelList, familyModels) || [];
      setModelOptions(
        familyModelList.map((model) => {
          return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
        }),
      );

      let loftDigitJoinTable = await getLoftDigitData();
      const lieDigitJoinTable = await getLieDigitsData();
      const lieFractionJoinTable = await getLieFractionData();
      loftDigitJoinTable = loftDigitJoinTable.filter((d) => d.headTypeId == WEDGE_HEAD_TYPE_ID); //get only wedge lofts
      const fractionSourceTable = await getFractionData();
      let loftFractionJoinTable = await getLoftFractionData();
      loftFractionJoinTable = loftFractionJoinTable.filter((f) => f.headTypeId == WEDGE_HEAD_TYPE_ID);

      const digitSourceTable = await getDigitData();
      setWedgeLoftKey(thisWedge.loftDigit + thisWedge.loftFraction);
      setWedgeLieKey(thisWedge.lieDigit + thisWedge.lieFraction);
      const { loftDropdownOptionMap, lieDropdownOptionMap } = LoftLieHelper.buildDropdownData({
        headTypeId: WEDGE_HEAD_TYPE_ID,
        digitSourceTable,
        fractionSourceTable,
        lieDigitJoinTable,
        lieFractionJoinTable,
        loftDigitJoinTable,
        loftFractionJoinTable,
      });
      setWedgeLoftOptions(loftDropdownOptionMap);
      setLoftOptions(loftDropdownOptionMap.options);
      setWedgeLieOptions(lieDropdownOptionMap);
      setLieOptions(lieDropdownOptionMap.options);

      const gripSizeData = await getGripSizeData();
      setGripSizeOptions(
        gripSizeData.map((grip) => {
          return { id: grip.gripSizeId.toString(), label: grip.name.toString() } as IDropdownOption;
        }),
      );

      //get swing weight lists and map them into a single list with a unique identifier
      const swingWtPrefix = await getSwingWtPrefixData();
      const swingWtSuffix = await getSwingWtSuffixData();
      let swingWeights = [] as IWeightCodes[];
      let swingWeightId = 1;
      swingWtPrefix.forEach((prefix) => {
        swingWtSuffix.forEach((suffix) => {
          swingWeights.push({
            swingWeightId: swingWeightId++,
            name: prefix.name + suffix.name,
            swingWtPrefixId: prefix.swingWtPrefixId,
            swingWtPrefixName: prefix.name,
            swingWtSuffixId: suffix.swingWtSuffixId,
            swingWtSuffixName: suffix.name,
          });
        });
      });
      setSwingWtData(swingWeights);

      setSwingWtOptions(
        swingWeights.map((sw) => {
          return { id: sw.swingWeightId.toString(), label: sw.name } as IDropdownOption;
        }),
      );
      swingWeightId = calculateSwingWeightIndex(thisWedge.swingWtPrefixId || 0, thisWedge.swingWtSuffixId || 0, swingWeights);
      setSwingWtListId(swingWeightId);

      const ironShafts = await getIronShaftByShaftNameForDropdownData();
      const wedgeShafts = await getWedgeShaftByShaftNameForDropdownData();
      let shaftData = [...ironShafts, ...wedgeShafts];
      shaftData = shaftData.sort((a, b) => a.name.localeCompare(b.name));
      // build manufacturer + shaft name dropdown options
      const shaftNameDropdownOptionMap = ShaftHelper.buildShaftDropdown(shaftData);
      setShaftDropdownData(shaftNameDropdownOptionMap);
      const tempShaftId = shaftNameDropdownOptionMap?.options.find((ironShaft) => ironShaft.label.endsWith(thisWedge.shaftName))?.id ?? '';
      setShaftId(thisWedge.shaftName ? tempShaftId : '');

      //find current shaftId given the shaft name (driver doesn't store shaftId)
      if (thisWedge.shaftName) {
        const shaft = shaftData.find((shaft) => shaft.name == thisWedge.shaftName);
        if (shaft) {
          setShaftId(shaft.id.toString());
        }
      }
      const shaftLengthDigitData = await getShaftLengthDigitData();
      const shaftLengthFractionData = await getShaftLengthFractionData();
      const shaftLengthFractions = createCombinedShaftLengthDigitFractionList(shaftLengthDigitData, shaftLengthFractionData, digitSourceTable, fractionSourceTable);
      setShaftLengthFractionData(shaftLengthFractions);
      setShaftLengthFractionOptions(
        shaftLengthFractions.map((sl) => {
          return { id: sl.name, label: sl.name } as IDropdownOption;
        }),
      );
      //find the current shaft length club and assign it to the dropdown field
      if (thisWedge.shaftLengthDigitId !== 0) {
        const shaftLength = shaftLengthFractions.find((sl) => sl.shaftLengthDigitId == thisWedge.shaftLengthDigitId && sl.fractionId == thisWedge.shaftLengthFractionId);
        if (shaftLength) {
          setShaftLengthName(shaftLength.name);
        }
      }
    };
    asyncProc();
  }, []);

  const handleHeadFinishWedgeChange = (id: string) => {
    const finish = headFinishWedgeOptions.find((f) => f.id == id);
    setThisWedge({ ...thisWedge, headFinishId: Number(id), headFinishName: finish?.label || '' });
  };

  //convert "RH", "LH" to the numerical handId
  const getCurrentHandId = (handName: string, hands: HandLookup[]) => {
    const handRecord = hands.find((hand) => hand.name == handName);
    return handRecord ? handRecord.handId : 0;
  };

  const bagClicked = () => {
    setThisWedge({ ...thisWedge, isActive: !thisWedge.isActive });
  };

  const handleFamilyChange = (id: string) => {
    const familyName = familyOptions.find((family) => family.id == id)?.label || '';
    const familyId = Number(id);
    setThisWedge({ ...thisWedge, familyId: familyId, familyName: familyName, headModelId: 0 }); //deselect model when family is updated
    const familyModelList = getModels(familyId, currentHandId, handModels, familyModelData) || [];
    setModelOptions(
      familyModelList.map((model) => {
        return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
      }),
    );
  };

  const getModels = (familyId: number | undefined, handId: number, handModels: HeadModelHandForDropdownDto[], familyModelData: HeadModelForDropdownDto[]) => {
    let modelList = [] as HeadModelForDropdownDto[];
    const modelIds = handModels.filter((model) => model.handId == handId).map((m) => m.headModelId);
    familyModelData
      .filter((m) => m.familyId == familyId)
      .forEach((m) => {
        if (modelIds.includes(m.headModelId)) {
          modelList.push(m);
        }
      });
    return modelList;
  };

  const handleModelChange = async (id: string) => {
    const modelId = Number(id);
    const modelName = modelOptions.find((model) => model.id == id)?.label || '';
    setThisWedge({ ...thisWedge, headModelId: modelId, headModelName: modelName, loftId: 0 });
  };

  const handleHandChange = (id: string) => {
    setThisWedge({ ...thisWedge, hand: id });
    const currentHandIdData = getCurrentHandId(id, handData);
    setCurrentHandId(currentHandIdData);

    //Get new Models dropdown and determine if current model should be reset or not based on the hand Id
    const familyModelList = getModels(thisWedge.familyId, currentHandIdData, handModels, familyModelData) || [];
    let thisModelOptions = familyModelList.map((model) => {
      return { id: model.headModelId?.toString() || '', label: model.name } as IDropdownOption;
    });
    setModelOptions(thisModelOptions);
  };

  const handleSwingWtChange = (id: string) => {
    const sw = swingWtData.find((sw) => sw.swingWeightId == Number(id));
    if (sw) {
      setSwingWtListId(sw.swingWeightId);
      setThisWedge({ ...thisWedge, swingWtPrefixId: sw.swingWtPrefixId, swingWtPrefixName: sw.swingWtPrefixName, swingWtSuffixId: sw.swingWtSuffixId, swingWtSuffixName: sw.swingWtSuffixName });
    }
  };

  const calculateSwingWeightIndex = (prefixId: number, suffixId: number, weightCodes: IWeightCodes[]) => {
    let id = 0;
    const weightCode = weightCodes.find((wc) => wc.swingWtPrefixId == prefixId && wc.swingWtSuffixId == suffixId);
    if (weightCode) {
      id = weightCode.swingWeightId;
    }
    return id;
  };

  const handleShaftFinished = () => {
    setThisWedge({ ...thisWedge, isShaftLengthFinished: !thisWedge.isShaftLengthFinished });
  };

  const handleNotesChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    setThisWedge({ ...thisWedge, notes: target.value });
  };

  const handleGrindDetailsChange = ({ target }: ChangeEvent<HTMLTextAreaElement>) => {
    setThisWedge({ ...thisWedge, grindDetails: target.value });
  };

  const serializeShafts = (setShaftName: string) => {
    const baseName = setShaftName.replace(/\s#\d+$/, '').trim();
    const shaftGroup = shaftDropdownData?.groups[baseName];
    if (!shaftGroup || shaftGroup.length === 0) return;

    // Find the index of the selected shaft
    const startIndex = shaftGroup.findIndex((s) => s.label.trim() === setShaftName.trim());
    const initialIndex = startIndex >= 0 ? startIndex : 0;
    const shaftIndex = Math.min(initialIndex, shaftGroup.length - 1);
    const shaft = shaftGroup[shaftIndex];
    const shaftName = shaft.label;
    const shaftPinstamp = shaft.shaftPinstamp;
    setThisWedge({ ...thisWedge, shaftName, shaftPinstamp });
  };

  const handleShaftLengthChange = (id: string) => {
    setShaftLengthName(id); //50 1/8
    const shaftLengthObject = shaftLengthFractionData.find((sl) => sl.name == id);
    setThisWedge({
      ...thisWedge,
      shaftLengthDigit: shaftLengthObject?.digit || '',
      shaftLengthDigitId: shaftLengthObject?.shaftLengthDigitId,
      shaftLengthDigitId1: shaftLengthObject?.digitId,
      shaftLengthFraction: shaftLengthObject?.fractionName || '',
      shaftLengthFractionId: shaftLengthObject?.shaftLengthFractionId || 0,
      shaftLengthFractionId1: shaftLengthObject?.shaftLengthFractionId || 0,
    });
  };

  const handleDropdownChange = (value: string, fieldName: string) => {
    setThisWedge({ ...thisWedge, [fieldName]: value });
  };

  const handleLoftChange = (id: string) => {
    const wedgeLoft = wedgeLoftOptions?.map[id];
    if (wedgeLoft) {
      setThisWedge({
        ...thisWedge,
        loftId: wedgeLoft.joinTableDigitId,
        loftDigit: wedgeLoft.loftDigit || '',
        loftFraction: wedgeLoft.loftFraction || '',
        loftFractionId: wedgeLoft.joinTableFractionId,
        loftFractionId1: wedgeLoft.sourceTableFractionId || 0,
      });
    }
  };

  const handleLieChange = (id: string) => {
    const wedgeLoft = wedgeLieOptions?.map[id];
    if (wedgeLoft) {
      setThisWedge({
        ...thisWedge,
        lieDigitId: wedgeLoft.joinTableDigitId,
        lieDigit: wedgeLoft.lieDigit || '',
        lieFraction: wedgeLoft.lieFraction || '',
        lieFractionId: wedgeLoft.joinTableFractionId,
        lieFractionId1: wedgeLoft.sourceTableFractionId || 0,
      });
    }
  };

  const handleGripSizeChange = (id: string) => {
    const gripSize = gripSizeOptions.find((grip) => grip.id == id)?.label || '';
    setThisWedge({ ...thisWedge, gripSizeId: Number(id), gripSize: gripSize });
  };

  const handleInputChange = (newValue: string, field: string) => {
    setThisWedge({ ...thisWedge, [field]: newValue });
  };

  const handleUpdateFinalHW = (partialWedge: IFinalHeadWeightIron) => {
    // update local state
    setHeadWeight(partialWedge.headWeight || 0);
    setDrill(partialWedge.drill);
    setTipPlug(partialWedge.tipPlug);
    setGlueWeight(partialWedge.glueWeight);
    setLeadTape(partialWedge.leadTape);
    setThisWedge({
      ...thisWedge,
      headWeight: partialWedge.headWeight || 0,
      drill: partialWedge.drill,
      tipPlug: partialWedge.tipPlug,
      glueWeight: partialWedge.glueWeight,
      leadTape: partialWedge.leadTape,
    });
  };

  return (
    <>
      <div className={styles.fullscreen}>
        <div className={styles.form}>
          <div className={styles.row}>
            <div className={styles.page_title}>{pageType} Club</div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown label="Hand" initialId={thisWedge.hand} options={handOptions} onChange={(id) => handleHandChange(id)} className={styles.editableDropdown} />
            </div>
            <EditableDropdown
              label="Finish"
              initialId={thisWedge.headFinishId?.toString() || ''}
              options={headFinishWedgeOptions}
              onChange={(id) => handleHeadFinishWedgeChange(id)}
              variant="large"
              className={styles.editableDropdown}
            />
            <EditableTile label="Finish Note" value={thisWedge.headFinishNote} onChange={(value) => handleInputChange(value, 'headFinishNote')} variant="xxl" />
            <div>
              <label className={styles.switch}>
                <input type="checkbox" checked={thisWedge.isActive} onChange={bagClicked} />
                <span className={styles.slider}></span>
              </label>
              <span className={styles.switch_text}>{`${thisWedge.isActive ? 'In the bag' : 'Out of Bag'}`}</span>
            </div>
          </div>
          <div className={styles.tileRow}>
            <div className={`${styles.input}`}>
              <EditableDropdown
                label="Family"
                initialId={thisWedge.familyId?.toString() || ''}
                options={familyOptions}
                onChange={(id) => handleFamilyChange(id)}
                className={styles.editableDropdown}
                variant="large"
              />
            </div>
            <EditableTile label="Family Note" value={thisWedge.familyNote} onChange={(value) => handleInputChange(value, 'familyNote')} variant="xxl" />
            <div className={`${styles.input} ${styles.size2}`}>
              <EditableDropdown
                label="Model"
                initialId={thisWedge.headModelId?.toString() || ''}
                options={modelOptions}
                onChange={(id) => handleModelChange(id)}
                className={styles.editableDropdown}
                variant="large"
              />
            </div>
            {/* <EditableTile label="Stamping" value={thisWedge.stamping} onChange={(value) => handleInputChange(value, 'stamping')} variant="large" /> */}
            <TextAreaInput label="Stamping" value={thisWedge.stamping} onChange={(value) => handleInputChange(value, 'stamping')} variant="halfSize" />
          </div>
          <div className={styles.tileRow}>
            <EditableDropdown label="Loft" initialId={wedgeLoftKey} options={loftOptions} onChange={(id) => handleLoftChange(id)} className={styles.editableDropdown} variant="large" />
            <EditableDropdown label="Lie" initialId={wedgeLieKey} options={lieOptions} onChange={(id) => handleLieChange(id)} className={styles.editableDropdown} variant="large" />
            <EditableDropdown
              label="Swing Wt"
              initialId={swingWtListId?.toString() || ''}
              options={swingWtOptions}
              onChange={(id) => handleSwingWtChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <span className={clubStyles.finalHWWrapper} role="button" onClick={() => setShowFinalHWModal(true)}>
              <Tile label="Final HW" value={normalizeString(finalHeadWeight?.toString())} tileStyle={clubStyles.finalHW} />
            </span>
          </div>
          <div className={styles.row}>
            <div className={styles.section_header}>Grind Details</div>
          </div>
          <div className={styles.tileRow}>
            <textarea className={clubStyles.editNotes} value={thisWedge.grindDetails} name="grindDetails" onChange={(value) => handleGrindDetailsChange(value)} rows={2} />
          </div>
          <div className={styles.row}>
            <div className={styles.section_header}>Shaft</div>
          </div>
          <div className={styles.tileRow}>
            <EditableDropdown
              label="Shaft"
              initialId={shaftId || ''}
              onChange={(shaftId) => {
                setShaftId(shaftId);
                const shaftName = shaftDropdownData?.map[shaftId].name || '';
                serializeShafts(shaftName);
              }}
              options={shaftDropdownData?.options || []}
              type="rectangle"
              alignment="left"
              variant="xxxxl"
            />
          </div>
          <div className={styles.tileRow}>
            <EditableTile label="Shaft Cosmetic" value={thisWedge.shaftCosmetic} onChange={(value) => handleInputChange(value, 'shaftCosmetic')} variant="large" />
            <EditableDropdown
              label="Length"
              initialId={shaftLengthName}
              options={shaftLengthFractionOptions}
              onChange={(id) => handleShaftLengthChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <div className={`${styles.input} ${styles.radioButtons}`}>
              <label className={styles.radioLabel}>
                <input type="radio" name="groupName" value="option1" checked={!thisWedge.isShaftLengthFinished} onChange={handleShaftFinished} /> Cut
              </label>
              <label>
                <input type="radio" name="groupName" value="option1" checked={thisWedge.isShaftLengthFinished} onChange={handleShaftFinished} /> Finished
              </label>
            </div>
          </div>
          <div className={styles.row}>
            <div className={styles.section_header}>Grip</div>
          </div>
          <div className={styles.tileRow}>
            <EditableTile label="Grip Type" value={thisWedge.gripType} onChange={(value) => handleInputChange(value, 'gripType')} variant="extra" />
            <EditableDropdown
              label="Grip Size"
              initialId={thisWedge.gripSizeId?.toString() || ''}
              options={gripSizeOptions}
              onChange={(id) => handleGripSizeChange(id)}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableDropdown
              label="Round/Rib"
              initialId={thisWedge.rndRib || ''}
              options={rndRibOptions}
              onChange={(id) => handleDropdownChange(id, 'rndRib')}
              className={styles.editableDropdown}
              variant="large"
            />
            <EditableDropdown label="Logo" initialId={thisWedge.logo} options={logoOptions} onChange={(id) => handleDropdownChange(id, 'logo')} className={styles.editableDropdown} variant="large" />
            <EditableTile label="Grip Tape" value={thisWedge.tape} onChange={(value) => handleInputChange(value, 'tape')} variant="large" />
          </div>
          <div className={styles.row}>
            <div className={styles.section_header}>Notes</div>
          </div>
          <div className={styles.row}>
            <textarea className={clubStyles.editNotes} value={thisWedge.notes} name="notes" onChange={(value) => handleNotesChange(value)} rows={5} />
          </div>
          <div className={styles.section_header}>
            <button className={clubStyles.saveButton} onClick={() => saveEditForm(thisWedge)}>
              Save
            </button>
            <button className={clubStyles.cancelButton} onClick={closeEditForm}>
              Cancel
            </button>
          </div>
        </div>
      </div>
      {showFinalHWModal && (
        <FinalHeadWeightModal showFinalHWModal={showFinalHWModal} closeFinalHWModal={() => setShowFinalHWModal(false)} iron={finalHWWedge} handleUpdate={handleUpdateFinalHW} isEditMode={true} />
      )}
    </>
  );
}
